export default "__VITE_ASSET__BTssHlWq__"